import apiClient from './apiClient';

export const sendMessage = (user_session_id, question_id, message) => {
    return apiClient.post(`/chat/${user_session_id}`, {
      question_id: question_id,
      message: message,
    });
  };